import styled, { css } from 'styled-components';
import { Badge as BootstrapBadge } from 'react-bootstrap';

import {
  PRIMARY_BLUE,
  LIGHT_BLUE,
  POSITIVE_GREEN,
  POSITIVE_GREEN_BG,
  DARK_GREY,
  BACKGROUND_GREY,
  ERROR_RED,
  ERROR_RED_BG,
  YELLOW,
  YELLOW_BG,
  WHITE,
  LIGHT_PURPLE,
  DARK_PURPLE,
  NEW_GREY,
  DARK_BLACK,
  LIGHTEST_GREY
} from 'constants/colours';

const VARIANTS: { [key: string]: { bg: string; color: string } } = {
  green: {
    bg: POSITIVE_GREEN_BG,
    color: POSITIVE_GREEN
  },
  white: {
    bg: WHITE,
    color: DARK_BLACK
  },
  grey: {
    bg: BACKGROUND_GREY,
    color: DARK_BLACK
  },
  private: {
    bg: BACKGROUND_GREY,
    color: DARK_GREY
  },
  red: {
    bg: ERROR_RED_BG,
    color: ERROR_RED
  },
  yellow: {
    bg: YELLOW_BG,
    color: YELLOW
  },
  black: {
    bg: DARK_GREY,
    color: WHITE
  },
  purple: {
    bg: LIGHT_PURPLE,
    color: DARK_PURPLE
  },
  success: {
    bg: POSITIVE_GREEN,
    color: WHITE
  },
  newGrey: {
    bg: NEW_GREY,
    color: DARK_BLACK
  },
  default: {
    bg: LIGHT_BLUE,
    color: PRIMARY_BLUE
  },
  lightestGrey: {
    bg: LIGHTEST_GREY,
    color: DARK_BLACK
  }
};

const Badge = styled(BootstrapBadge)<{
  variant: keyof typeof VARIANTS;
  compact?: boolean;
}>(
  ({ variant = 'default', compact = false }) => css`
    margin: 0;
    padding: ${compact ? '3px 6px' : '6px 8px'};
    background: ${VARIANTS[variant]?.bg || VARIANTS.default.bg};
    font-size: ${compact ? '12px' : '14px'};
    line-height: ${compact ? '16px' : '20px'};
    font-weight: ${compact && '500'};
    color: ${VARIANTS[variant]?.color || VARIANTS.default.color};
    border: ${variant === 'white' ? `1px solid ${NEW_GREY}` : 'none'};
    border-radius: 8px;
  `
);

export default Badge;
